module.exports = __webpack_public_path__ + "static/media/about_pollination2.0cb361fc.webp";